export default __webpack_public_path__ + "static/media/POTATO_STAGE_2.5a2f61e4.png";